import { Capacitor } from '@capacitor/core'

export const isIosApp = () => Capacitor.getPlatform() === 'ios'

export const paymentsEnabled = () => !isIosApp()

export const ANDROID_APP_SCHEME = 'com.kimsa.builder'

export const IOS_APP_SCHEME = 'com.builderpro.app'

export const STUDENTS_APP_SCHEME = 'com.kimsa.builderpro.students'

export const APP_SCHEMES = [ANDROID_APP_SCHEME, IOS_APP_SCHEME]

export const isIosDevice = () => {
    if (typeof navigator === 'undefined') return false
    if (/iPad|iPhone|iPod/.test(navigator.userAgent || '')) return true
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
}
